import {inject, NgModule} from '@angular/core';
import {environment} from '../environments/environment';
import {SessionService} from './@core/session.service';
import {provideApollo} from 'apollo-angular';
import {ApolloLink, InMemoryCache, split} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {setContext} from '@apollo/client/link/context';
import {GraphQLWsLink} from '@apollo/client/link/subscriptions';
import {createClient} from 'graphql-ws';

import {getMainDefinition} from '@apollo/client/utilities';
import {OperationDefinitionNode} from 'graphql/language';

const uri = `https://${environment.graphEndpoint}`;
const wsUri = `wss://${environment.graphEndpoint}`;

export function createApollo(httpLink: HttpLink, sess: SessionService): any {
  const getToken = async () => {
    const token = await sess.getToken();
    return token ? {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    } : {headers: {}};
  };
  const auth = setContext(getToken);
  const http = ApolloLink.from([auth, httpLink.create({uri, withCredentials: true})]);

  const ws = new GraphQLWsLink(
    createClient({
      url: wsUri,
      lazy: true,
      connectionParams: getToken,
      shouldRetry: () => true,
    })
  );
  const link = split(
    ({query}) => {
      const {kind, operation} = getMainDefinition(query) as OperationDefinitionNode;
      return (
        kind === 'OperationDefinition' && operation === 'subscription'
      );
    },
    ws,
    http,
  );

  return {
    link,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache' as const,
        errorPolicy: 'none' as const,
      },
      query: {
        fetchPolicy: 'no-cache' as const,
        errorPolicy: 'none' as const,
      },
    }
  } as any;
}

@NgModule({
  providers: [
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const sess = inject(SessionService);
      return createApollo(httpLink, sess);
    }),
  ],
})
export class GraphQLModule {
}
